import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { marketplaceApi } from "../api/client";
import MarketplaceHeader from "../components/MarketplaceHeader";
import ProductCard from "../components/ProductCard";
import FloatingTools from "../components/FloatingTools";
import Footer from "../components/Footer";

export default function CategoryProducts() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [payload, setPayload] = useState({ category: null, subcategories: [], products: [], stats: {} });
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    marketplaceApi.categoryDetail(code)
      .then((res) => { if (active) setPayload(res.data || {}); })
      .catch(() => { if (active) setError("This category could not be loaded from the marketplace engine."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [code]);

  const products = payload.products || [];
  const filtered = useMemo(() => {
    const clean = query.trim().toLowerCase();
    if (!clean) return products;
    return products.filter((item) => `${item.title} ${item.brand || ""} ${item.seller_display || item.seller_name || ""}`.toLowerCase().includes(clean));
  }, [products, query]);

  const categoryName = payload.category?.name || "Category";

  function searchEverywhere(event) {
    event.preventDefault();
    if (!query.trim()) return;
    navigate(`/search?q=${encodeURIComponent(query.trim())}&tab=Products`);
  }

  return (
    <div className="page-shell category-marketplace-page" id="top">
      <MarketplaceHeader apiOnline />
      <main className="container category-marketplace-layout">
        <section className="marketplace-title-banner">
          <img src="/images/tazy-marketplace-banner.png" alt="" />
          <div className="marketplace-title-banner__content">
            <Link to="/" className="back-link">← Back to marketplace</Link>
            <span>TAZY CART CATEGORY</span>
            <h1>{categoryName}</h1>
            <p>Browse verified listings under this category. Product entry can still use subcategories internally while buyers enjoy a clean category page.</p>
            <form onSubmit={searchEverywhere} className="marketplace-title-search">
              <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder={`Search ${categoryName.toLowerCase()} products`} />
              <button type="submit">Search</button>
            </form>
          </div>
        </section>

        {payload.subcategories?.length > 0 && (
          <section className="subcategory-pill-row subcategory-pill-row--clean">
            {payload.subcategories.map((item) => <span key={item.id}>{item.name}</span>)}
          </section>
        )}

        <section className="products-section products-section--compact category-products-section">
          <div className="section-heading">
            <div>
              <h2>{loading ? "Loading listings..." : `${filtered.length} listing(s) in ${categoryName}`}</h2>
              <p>Products are grouped under this marketplace category.</p>
            </div>
            <Link to="/request">Request sourcing help</Link>
          </div>
          {error ? <div className="marketplace-empty-feed">{error}</div> : (
            <div className="product-grid product-grid--compact product-grid-v2">
              {filtered.length ? filtered.map((item) => <ProductCard key={item.id} item={item} />) : <div className="marketplace-empty-feed">No public listings in this category yet.</div>}
            </div>
          )}
        </section>
      </main>
      <Footer />
      <FloatingTools />
    </div>
  );
}
